angular.module('bmsApp.settings')
	.controller('OnlineCleaningPricingModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  LicenseOptionsSvc,
				  SMCleaningServiceSvc,
				  TaxHelperSvc,
		) {


			function init() {
				LicenseOptionsSvc.license().then((response) => {
					self.options.licenses = response.data.options;
				});
			}

			function licenseChanged() {
				SMCleaningServiceSvc.options({licenseId: self.license.id, onlineOnly: true}).then((response) => {
					let services = response.data.cleaning_service_options;
					let groups = [];
					let groupedServices = _.groupBy(services, function(service) {
						return service.category.id;
					});
					angular.forEach(groupedServices, (groupService) => {
						groups.push({
							category: groupService[0].category,
							services: [],
						});
					});

					angular.forEach(groups, (group) => {
						angular.forEach(services, (service) => {
							service.gross = TaxHelperSvc.grossFromNet(service.value);
							if (service.category.id === group.category.id) {
								group.services.push(service);
							}
						});
					});
					self.groups = groups;
					console.log(self.groups);
				});
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}


			var self = $scope.OnlineCleaningPricingModalCtrl = {
				loading: true,
				job: {},
				options: {},
				methods: {
					init: init,
					cancel: cancel,
					licenseChanged: licenseChanged
				}
			}

		});
